import { render, staticRenderFns } from "./CorrerEvento.vue?vue&type=template&id=0fca1472"
import script from "./CorrerEvento.vue?vue&type=script&lang=js"
export * from "./CorrerEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fca1472')) {
      api.createRecord('0fca1472', component.options)
    } else {
      api.reload('0fca1472', component.options)
    }
    module.hot.accept("./CorrerEvento.vue?vue&type=template&id=0fca1472", function () {
      api.rerender('0fca1472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/CorrerEvento.vue"
export default component.exports